import type { RecordModificationResponse } from "#root/utility/remote-data";

type Row = Record<string, unknown>;

export type MergeDataType<T extends Row> = (RecordModificationResponse<T>) | ({ id: string } & T);

export function mergeUpdate<T extends Row>(collection: T[], data: MergeDataType<T>): T[] | undefined {
  try {
    //TODO: I have no idea what response type uses the V1 pathway
    // Version 1 response
    if ("id" in data) {
      // Mutate container
      const col = [...collection];
      // Find the data item
      const idx = col.findIndex(element => element.id === data.id);
      if (idx >= 0) {
        // It exists
        if ("deleted" in data) {
          // So delete it
          col.splice(idx, 1);
        } else {
          // So update it
          col[idx] = { ...data };
        }
      } else if (!data.deleted) {
        // Does not exist and not being deleted, so being created
        col.push(data);
      }

      return col;
    }

    // Version 2 data responses
    if ("created" in data) {
      return [...collection, data.row];
    }

    if ("updated" in data) {
      const idx = collection.findIndex(element => element.id === data.updated);
      if (idx === -1) {
        throw new Error("Couldn't find updated record in collection");
      }

      const newCollection: T[] = [];
      for (const [i, element] of collection.entries()) {
        newCollection.push(i === idx ? data.row : element);
      }

      return newCollection;
    }

    if ("deleted" in data) {
      const idx = collection.findIndex(element => element.id === data.deleted);
      if (idx === -1) {
        throw new Error("Couldn't find deleted record in collection");
      }

      const newCollection: T[] = [];
      for (const [i, element] of collection.entries()) {
        if (i === idx) {
          // Console.log(i, idx, data.row);
          // If a row was passed back, the delete was an update
          if (data.row) {
            newCollection.push(data.row);
          }
        } else {
          newCollection.push(element);
        }
      }

      return newCollection;
    }

    console.log("No merge action detected in response:", data);
    return collection;
  } catch (error) {
    console.log("Error merging data:", error);
  }
}
